import React, { useEffect, useMemo } from 'react';
import './ProfileListing.scss';

import emptyIllustration from './img/empty.png';
import { thumbImgProps, fallbackToOriginal } from "../../utils/imageUrl";

import {
  HARD_TTL,
  cacheGetStale,
  cacheSet,
} from '../../utils/swrcache';

const DEFAULT_AVATAR_URL = 'https://cvanto-photos.s3.us-east-1.amazonaws.com/DefaultAvatar/avatar.png';

const TTL_5MIN = 5 * 60 * 1000;
const TTL_24H = 24 * 60 * 60 * 1000;

export default function ProfileListing({
  listings,
  isStaff = false,
  deepItem,
  onOpenListing,
  userId,
}) {
  const cacheKey = userId ? `profile:listings:${userId}` : null;

    const hydrated = (() => {
    if (!cacheKey) return null;
    const c = cacheGetStale(cacheKey, TTL_5MIN);
    return Array.isArray(c) ? c : null;
  })();

  const isLoading = !Array.isArray(listings) && !Array.isArray(hydrated);

    const sourceListings = Array.isArray(listings)
    ? listings
    : (Array.isArray(hydrated) ? hydrated : null);

  const effectiveListings = Array.isArray(sourceListings)
    ? sourceListings.filter((it) => {
        const rawType = String(it?.listingType || it?.type || '').toLowerCase();
        return rawType !== 'wanted';
      })
    : null;

    useEffect(() => {
    if (!cacheKey) return;
    if (!Array.isArray(sourceListings)) return;

    if (sourceListings.length > 0) {
      cacheSet(cacheKey, sourceListings);
      return;
    }

    const existing = cacheGetStale(cacheKey, TTL_24H);
    if (!existing) {
      cacheSet(cacheKey, []);
    }
  }, [cacheKey, sourceListings]);


  if (isLoading) {
    return (
      <div className="profile-content-section">
        <div className="profile-feed feed profile-feed--skeleton">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div key={idx} className="ad-card ig-card ad-card--skeleton">
              <div className="ad-thumb ig-thumb" />
              <div className="ad-caption ig-caption">
                <div className="ad-title ig-title" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!effectiveListings || effectiveListings.length === 0) {
    return (
      <div className="profile-content-section">
        <div className="empty-state" role="status" aria-live="polite">
          <img className="empty-state__img" src={emptyIllustration} alt="" />
          <p className="empty-state__text">Поки що немає оголошень</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-content-section">
      <div className="ads-grid ig-grid">
        {effectiveListings.map((ad) => {
          const id = ad.listingId || ad.id;
          const isDeep = String(id) === String(deepItem);
          const isUnderReview = !!ad.__autoHidden && isStaff;

          return (
            <button
              key={id}
              className={`ad-card ig-card ${isDeep ? 'pulse-highlight' : ''}`}
              onClick={() => onOpenListing?.(id)}
              aria-label={`Відкрити оголошення: ${ad.title}`}
              data-ad-id={id}
            >
              <div className="ad-thumb ig-thumb">
                <img
                  {...thumbImgProps(ad.mainPhoto, "(max-width: 600px) 34vw, 220px")}
                  alt={ad.title}
                  onError={fallbackToOriginal(ad.mainPhoto, DEFAULT_AVATAR_URL)}
                />
                {isUnderReview && (
                  <div className="ad-review-overlay">
                    <div className="ad-review-badge">Приховано через скарги</div>
                    <div className="ad-review-text">Очікує рішення модератора</div>
                  </div>
                )}
              </div>
              <div className="ad-caption ig-caption">
                <div className="ad-title ig-title">{ad.title}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}